var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"RealTime"}},[_c('div',{staticClass:"header-time",staticStyle:{"font-size":"48px"}},[_vm._v("\n    "+_vm._s(_vm.nowTime)+"\n    "),_c('span',{staticClass:"week"},[_vm._v(_vm._s(_vm.week))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6a38f7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/realTime/realTime.vue
// module id = null
// module chunks = 